export default "__VITE_ASSET__89123943__"